import React from 'react';
import { useSite } from '../content/SiteContext';

const AdvergamesSection = () => {
  const { content, t } = useSite();
  const section = content.advergames;
  const whatsappNumber = String(content.projects.whatsappNumber || '').replace(/\D/g, '');

  return (
    <section id="advergames" className="py-16 md:py-20 bg-gradient-to-br from-gray-900 via-gray-800 to-black">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12 md:mb-16">
          <h2
            className="section-heading text-white reveal"
            style={{
              fontSize: 'clamp(2rem, 6vw, 2.5rem)',
              fontWeight: 700,
              marginBottom: '1rem',
              textAlign: 'center',
              fontFamily: 'Inter, sans-serif'
            }}
          >
            <span
              className="text-gradient"
              style={{
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                color: 'transparent',
                backgroundImage: 'linear-gradient(to right, #a78bfa, #f472b6)'
              }}
            >
              {t(section.title)}
            </span>
          </h2>
          <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto px-4">
            {t(section.subtitle)}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {(section.cards || []).map((card, index) => (
            <div key={index} className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 md:p-8 text-center hover:bg-white/10 transition-all duration-300">
              {card.icon && (
                <div className="flex justify-center mb-4">
                  <img src={card.icon} alt={t(card.title)} className="w-16 h-16 object-contain filter brightness-0 invert" />
                </div>
              )}
              <h3 className="text-xl font-bold text-white mb-3">{t(card.title)}</h3>
              <p className="text-gray-300 text-sm md:text-base">
                {t(card.description)}
              </p>
            </div>
          ))}
        </div>

        {/* Información adicional */}
        <div className="bg-gradient-to-r from-purple-500/10 to-pink-500/10 backdrop-blur-sm border border-white/20 rounded-3xl p-8 md:p-12 text-center">
          <h3 className="text-2xl md:text-3xl font-bold text-white mb-6">
            {t(section.whyTitle)}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-left">
            {(section.reasons || []).map((reason, index) => (
              <div key={index}>
                <h4 className={`text-lg font-semibold mb-2 ${index % 2 ? 'text-pink-400' : 'text-purple-400'}`}>✓ {t(reason.title)}</h4>
                <p className="text-gray-300 text-sm md:text-base">
                  {t(reason.description)}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Call to Action */}
        <div className="text-center mt-12">
          <a
            href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(t(section.ctaMessage))}`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block px-8 py-4 bg-gradient-to-r from-purple-600 to-pink-600 text-white font-bold rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 text-base md:text-lg"
          >
            {t(section.ctaText)}
          </a>
        </div>
      </div>
    </section>
  );
};

export default AdvergamesSection;
